import { css } from '@emotion/react';

import { ZeeFontRegular } from 'src/styles/font';
import { PlaceholderImg } from 'src/styles/utils';

import { colors } from '../../../../styles/colors';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';
import { ThumbnailTypes } from '../../types';

export const placeholder2X3 = css`
  & img {
    width: 100%;
    border-radius: 6px;
  }
  ${PlaceholderImg(3, 2, '/images/placeholder_ZEE5.svg')};
`;

export const contentItemFigure = (
  thumbnailType: ThumbnailTypes,
  X: number,
  Y: number
) => css`
  margin: 0;
  position: relative;
  height: 100%;
  padding-top: ${(Y / X) * 100}%;
  :after {
    content: '';
    position: absolute;
    border-radius: 12px;
    border: 0 solid ${colors.white};
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: -1;
  }
  & > img {
    ${thumbnailType !== ThumbnailTypes.bellybanner
      ? `border-radius: 6px;
    transform: translateZ(0);
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    `
      : ''}
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    ${thumbnailType === ThumbnailTypes.circular ? 'border-radius:50%;' : ''}
    cursor: pointer;
  }
`;

export const cardPremiunIconContainer = (iconFlag: boolean) => css`
  height: 14px;
  width: 14px;
  margin: 4px 0 4px 4px;
  float: left;
  text-align: center;
  background: ${colors.PrimaryWhiteColor} center / 100% 100% no-repeat
    url('/webapp-assets/images/premium.svg?ver=#{AppVersion}');
  border-radius: 50%;
  position: absolute;
  top: 0;
  box-shadow: 0 1px 2px 0 ${colors.PortalTransparentBg};
  ${iconFlag ? `top:3px;left:5px;` : ''}
  ${MQ.MediaSm} {
    height: 24px;
    width: 24px;
  }
  ${MQ.MediaXl} {
    height: 26px;
    width: 26px;
  }
`;

export const imgErrorFallbackTitle = (
  showIconFlag: boolean,
  isTvod: boolean,
  thumbnailType?: ThumbnailTypes
) => css`
  left: 0;
  position: absolute;
  top: 0;
  color: ${colors.white};
  overflow-wrap: anywhere;
  padding: 12px;
  text-align: left;
  z-index: 1;

  ${thumbnailType === ThumbnailTypes.upnext ? `${ZeeFontRegular(10, 12)};` : ``}

  /* For upnext and horizontal thumbnails we will show the title
    name beside and below the image respectively. */
  ${thumbnailType == ThumbnailTypes.vertical
    ? ZeeFontRegular(16, 18)
    : 'display: none'}

  ${showIconFlag
    ? `${MQ.MobileXs}{
      left: ${isTvod ? '3rem' : '1.5rem'};
      padding: ${isTvod ? '7px' : '5px'};
      ${ZeeFontRegular(11, 16)};
    }
    ${MQ.MediaSm}{
      left: ${isTvod ? '3.5rem' : '2rem'};
      padding: 10px;
      ${ZeeFontRegular(16, 18)};
    }`
    : ''}
`;
export const imgErrorFallbackIcon = css`
  bottom: 17px;
  left: 17px;
  position: absolute;
  & > img {
    width: 100%;
    height: 18px;
  }
`;

export const partnerLogoIcon = css`
  z-index: 1;
  width: 68%;
  position: absolute;
  top: 0;
`;

export const cardTvodIconContainer = (iconFlag: boolean) => css`
  height: 22px;
  width: 38px;
  float: left;
  text-align: center;
  background: ${colors.PrimaryBlackColorAlpha60} center / 85% 85% no-repeat
    url('/webapp-assets/images/zee-plex-logo.png');
  margin: 4px 0 4px 4px;
  position: absolute;
  top: 0;
  border-radius: 12px;
  ${iconFlag ? `top:3px;left:5px;` : ''}
  ${MQ.MediaSm} {
    height: 26px;
    width: 48px;
  }
  ${MQ.MediaXl} {
    height: 28px;
    width: 50px;
  }
`;

export const removeDefaultStyle = (thumbnailType: ThumbnailTypes) => css`
  ${ZeeFontRegular(0, 0)};
  ${thumbnailType == ThumbnailTypes.upnext ? 'min-width: 168px;' : ''}
`;
